import { LeaderContext } from "../context/LeaderContext";
import { useContext } from "react";

export const useLeaderContext = () => {
    const context = useContext(LeaderContext);

    if (!context) {
        return Error('useLeaderContext must be used inside an LeaderContextProvider');
    };

    return context;
};